// extracted by mini-css-extract-plugin
export default {"input":"InputWhite_input__ly6mc","textarea":"InputWhite_textarea__+oJof","wrapper":"InputWhite_wrapper__SUVHy","title":"InputWhite_title__fWshO"};